import { Localization } from 'static/localization/localization';

export const useCategoryTranslations = () => {
    const keysToTranslations = {
        _heritage: Localization.MAP_V2_CATEGORY_HERITAGE,
        _dining: Localization.MAP_V2_CATEGORY_DINING,
        _fun: Localization.MAP_V2_CATEGORY_FUN,
        _art: Localization.MAP_V2_CATEGORY_ART,
        _events: Localization.MAP_V2_CATEGORY_EVENTS
    };

    function translateTitle(title: string) {
        return keysToTranslations[title] ?? title;
    }

    return { translateTitle };
};
